import { AURA_SCAN_REPORT_MODAL_V1_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV1, type ReportPromoCopyV1 } from "./report-promo-modal-v1"

const COPY: ReportPromoCopyV1 = {
  reportId: ReportIds.AuraScan,
  planId: AURA_SCAN_REPORT_MODAL_V1_PLAN_ID,
  title: "Discover Your Unique Aura",
  description:
    "Reveal the colors, energy patterns, and qualities that make your aura uniquely yours",
}

export function ReportAuraScanModalV1(props: AppModalComponentProps) {
  return <ReportPromoModalV1 {...props} copy={COPY} />
}
